<template>
	<div class="cyBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="ctFlag" @qrsFn="confirmCtFn" @callFn="ctFlag = false" :title="`请选择试卷类型`">
			<div class="ct-dialog-content">
				<div class="ct-option-btn" :class="{ active: selectedPaperType === 'A' }" @click="selectedPaperType = 'A'">
					A卷
				</div>
				<div class="ct-option-btn" :class="{ active: selectedPaperType === 'B' }" @click="selectedPaperType = 'B'">
					B卷
				</div>
			</div>
		</dialogBox>
		<div class="cyTop">
			<div class="cyDelBtn cyDelBtns" @click="goToMySj">
				<img src="@/assets/img/编组 (12).png" alt="" />
				组合套题
			</div>
			<div class="cyDelBtn" @click="delQbFn">
				<img src="@/assets/img/编组 (11).svg" alt="" />
				全部删除
			</div>
		</div>
		<div class="cyCont">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" header-row-class-name="btClass" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" prop="status" :selectable="checkSelectable" width="80"></el-table-column>
				<el-table-column align="center" prop="title" label="试卷名">
					<template slot-scope="scope">
						<div class="spBox" @click="lookBtn(scope.row)">
							{{ scope.row.name }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="难易度">
					<template slot-scope="scope">
						<div style="display: flex;justify-content: center;">
							<div class="nydBox">
							{{ scope.row.adifficultyScore || 0 }}
						</div>
						<div>+</div>
						<div class="nydBox">
							{{ scope.row.bdifficultyScore || 0 }}
						</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="报告" align="center">
					<template slot-scope="scope">
						<div class="iconBox" @click="openCtDialog(scope.row)">
							<img src="@/assets/img/ctfb.svg" class="ztIcon" alt="" />
							错题分布
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';

export default {
	name: 'jikaoSj',
	data() {
		return {
			tableData: [],
			ruleForm: {
				examId: ''
			},
			rules: {
				examId: [{ required: true, message: '请选择试卷', trigger: 'change' }]
			},
			fullscreenLoading: false,
			delFlag: false,
			fxFlag: false,
			ctFlag: false,
			options: [],
			bjList: [],
			tabFlag: 1,
			multipleSelection: [],
			selectedPaperType: 'A',
			currentRow: null,
			dialogType: '' // 'ct' 错题分布, 'look' 查看试卷
		};
	},
	components: {
		dialogBox
	},
	props: ['bjId', 'a'],
	methods: {
		goToMySj() {
			this.$router.push('/mySj');
		},
		lookBtn(item) {
			this.currentRow = item;
			this.selectedPaperType = 'A';
			this.dialogType = 'look'; // 查看试卷
			this.ctFlag = true;
		},
		decFn() {
			this.$emit('fhBtn', 'kebenDec');
		},
		delQbFn() {
			if (this.multipleSelection.length) {
				let ids = this.multipleSelection.map(item => item.id);
				let strName = this.multipleSelection.map(item => item.name).join(',');
				this.$confirm(`是否删除${strName}?`, '提示', {
					confirmButtonText: '确认',
					confirmButtonClass: 'delBtns',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						let set = this.$loading(this.$pre);
						this.$http.post(`api/app/yydComputerizedExamPaper/deleteClassPaper`, ids).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.init();
							}
						});
					})
					.catch(() => {});
			} else {
				this.$message({
					message: '请勾选试卷',
					type: 'warning'
				});
			}
		},
		openCtDialog(item) {
			this.currentRow = item;
			this.selectedPaperType = 'A';
			this.dialogType = 'ct'; // 错题分布
			this.ctFlag = true;
		},
		confirmCtFn() {
			if (this.currentRow && this.selectedPaperType) {
				if (this.dialogType === 'ct') {
					// 错题分布
					console.log(this.currentRow, this.selectedPaperType, '98888');
					this.$emit('paperFn', this.currentRow.id, 6, this.selectedPaperType);
					this.$emit('fhBtn', 'banjiSjDecSec');
				} else if (this.dialogType === 'look') {
					// 查看试卷
					this.$router.push({
						path: './timDec',
						query: {
							type: 1,
							types: 'zt',
							txt: this.selectedPaperType == 'A' ? this.currentRow.sourceAName : this.currentRow.sourceBName,
							tabFtxt: this.a,
							groupExamId: this.selectedPaperType == 'A' ? this.currentRow.sourceAId : this.currentRow.sourceBId,
							crumFlag: 1,
							tabFtxt: ['首页', '机考套题'],
						}
					});
				}
				this.ctFlag = false;
			}
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		checkSelectable(row) {
			return !row.status;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydComputerizedExamPaper/classPaperList`,{
				params: {
						bjId: this.bjId,
					}
			}).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.tableData = res.rows || [];
					console.log(res, 9999);
				}
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.spBox {
	cursor: pointer;
}
.fxP {
	font-size: 14px;
	text-align: center;
	margin-bottom: 33px;
}
.cyBox {
	background: #ffffff;
	border-radius: 6px;
	.cyTop {
		height: 80px;
		padding: 0 21px 0 16px;
		display: flex;
		align-items: center;
		position: relative;
		justify-content: space-between;
		border-bottom: 1px solid #eeeff2;
		.cyDelBtn {
			width: 90px;
			height: 30px;
			background: rgba(247, 85, 45, 0.05);
			border: 1px solid #f7552d;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #f7552d;
			cursor: pointer;
			img {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}
		}
		.cyDelBtns {
			color: #fff;
			background: #1d7b3a;
			border: 1px solid #1d7b3a;
			img {
				width: 12px;
				height: 15px;
				margin-right: 4px;
			}
		}
	}
}
.imgs {
	width: 44px;
	height: 55px;
	background: #d8d8d8;
	border-radius: 4px;
}
.iconBox {
	display: flex;
	align-items: center;
	color: #fa4a1b;
	font-size: 14px;
	justify-content: center;
	cursor: pointer;
	img {
		width: 15px;
		height: 15px;
		margin-right: 6px;
	}
}
.delBox {
	text-align: center;
	img {
		width: 70px;
		height: 70px;
		margin-bottom: 39px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9d9d9d;
		font-size: 16px;
	}
}
.nydBox {
	width: 53px;
	height: 30px;
	border: 1px solid #1d7b3a;
	font-size: 14px;
	color: #1d7b3a;
	border-radius: 6px;
	margin: 0 10px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.ct-dialog-content {
	display: flex;
	justify-content: center;
	gap: 20px;
	padding: 20px 0;
	.ct-option-btn {
		width: 120px;
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		color: #333;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		cursor: pointer;
		transition: all 0.3s;
		&:hover {
			border-color: #f7552d;
			color: #f7552d;
		}
		&.active {
			background: #f7552d;
			color: #fff;
			border-color: #f7552d;
		}
	}
}
</style>
